import { Link } from 'react-router-dom';
import { mainSiteUrl } from '@/mocks/categories';

export default function SEOContent() {
  return (
    <section id="guia" className="py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16">
          <div className="flex-1">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-6">
              <i className="ri-book-open-line"></i>
              Guia CSSBuy
            </div>

            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-6">
              Como Usar o CSSBuy Sheet para Compras na China
            </h2>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
              O <strong>CSSBuySpreadsheet</strong> é a ferramenta mais eficiente para encontrar produtos de qualidade da China usando agentes de compra como CSSBuy. Com o crescimento do mercado de sneakers reps, streetwear e réplicas de luxo, os spreadsheets se tornaram essenciais para compradores internacionais que buscam os melhores preços e produtos exclusivos.
            </p>

            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
              Nosso <strong>CSSBuy spreadsheet</strong> é atualizado diariamente, garantindo que você sempre tenha acesso aos produtos mais recentes antes que esgotem. Cada link é verificado manualmente para oferecer a melhor experiência de compra.
            </p>

            <ul className="space-y-3 mb-8">
              {[
                'Acesso a produtos exclusivos direto da China',
                'Preços mais baixos do mercado internacional',
                'Atualizações diárias com novos produtos',
                'Comparações entre agentes chineses (CSSBuy, Pandabuy, Sugargoo)',
                'Guias completos para iniciantes e compradores avançados',
                'Dicas de segurança para evitar fraudes e scams',
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3 text-foreground-700 text-sm md:text-base">
                  <span className="flex-shrink-0 w-5 h-5 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center mt-0.5">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {item}
                </li>
              ))}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link
                to="/artigo-cssbuyspreadsheet-guia-completo-2026"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-200 whitespace-nowrap group"
              >
                Leia o Guia Completo
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
              </Link>
              <a
                href={mainSiteUrl}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-foreground-400 hover:text-foreground-900 transition-all duration-200 whitespace-nowrap"
              >
                Acessar CSSBuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1">
            <div className="relative rounded-2xl overflow-hidden h-full min-h-[320px] flex flex-col justify-between">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20warm%20toned%20abstract%20composition%20with%20soft%20terracotta%20camel%20and%20cream%20gradients%20flowing%20organically%20creating%20a%20sophisticated%20atmospheric%20background%20texture%20with%20subtle%20textural%20details&width=600&height=450&seq=seo-v2-quote-bg&orientation=landscape"
                alt=""
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-accent-900/85"></div>
              <div className="relative z-10 p-8 md:p-10 flex flex-col justify-between h-full">
                <div>
                  <div className="flex items-center justify-between mb-8">
                    <span className="text-xs font-medium text-accent-300/60 uppercase tracking-wider">Destaque</span>
                    <div className="flex gap-1">
                      <span className="w-1.5 h-1.5 rounded-full bg-accent-300/40"></span>
                      <span className="w-1.5 h-1.5 rounded-full bg-accent-300/40"></span>
                      <span className="w-1.5 h-1.5 rounded-full bg-accent-300/40"></span>
                    </div>
                  </div>
                  <blockquote className="font-heading text-xl md:text-2xl text-accent-50 leading-relaxed mb-8">
                    "O CSSBuySpreadsheet mudou completamente minha forma de comprar da China. Economizo tempo e dinheiro todos os meses."
                  </blockquote>
                </div>
                <div className="flex items-center gap-4">
                  <div className="w-10 h-10 rounded-full bg-accent-300/30 flex items-center justify-center text-accent-100 font-semibold text-sm">
                    CM
                  </div>
                  <div>
                    <p className="text-accent-50 text-sm font-semibold">Carlos Mendes</p>
                    <p className="text-accent-300/50 text-xs">Comprador Verificado desde 2024</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}